import { useQuery } from "@tanstack/react-query";

import { fetchInventory } from "@/api/inventory";
import { InventoryProduct } from "@/types/api/inventory";
import { TServerError } from "@/types/api/shared";
import { convertToObjectById } from "@/utils/byId";

export const INVENTORY_QUERY_KEY = "inventory";

interface CompleteInventory {
  productQuantities: InventoryProduct[];
  productQuantitiesBySku: {
    [id: string | number]: InventoryProduct;
  };
}

export async function getCompleteInventory() {
  const { products } = await fetchInventory();
  return {
    productQuantities: products,
    productQuantitiesBySku: convertToObjectById<InventoryProduct>(products),
  } as CompleteInventory;
}

export function useInventory() {
  return useQuery<CompleteInventory, TServerError>(
    [INVENTORY_QUERY_KEY],
    getCompleteInventory
  );
}
